import { CAT_NEWS } from 'App/utils/Collections';
import { ROLE_STAFF } from '@/app/constants/Roles';
import { loadCategories, loadThemes, loadLocations, loadRegions } from '@/components/filters/config/loaders';
import { FT_DATE, FT_CHECKBOX, FT_LIST, FT_AUTOCOMPLETE } from '../FilterTypes';
import store from 'App/store/vuex';

export const groups = {
  general: {
    name: 'General',
    groupOrderIndex: 0,
  },
  date: {
    name: 'Date',
    groupOrderIndex: 1,
  },
  location: {
    name: 'Location',
    groupOrderIndex: 2,
  },
};

export default {
  category: CAT_NEWS,
  filters: [
    {
      id: 'publishedAt',
      label: 'Publication Date',
      group: groups.date,
      type: FT_DATE,
    },
    {
      id: 'draft',
      label: 'Published',
      group: groups.general,
      type: FT_CHECKBOX,
      fieldConf: {
        inverseBoolean: true,
      },
      defaultValue: () => false,
      roles: [ROLE_STAFF],
    },
    {
      id: 'categories',
      label: 'Categories',
      group: groups.general,
      type: FT_LIST,
      getListItems: loadCategories,
    },
    {
      id: 'types',
      label: 'Themes',
      type: FT_AUTOCOMPLETE,
      group: groups.general,
      fieldConf: {
        items: () => loadThemes('', store.state.modules[CAT_NEWS]),
        searcher: (term) => loadThemes(term, store.state.modules[CAT_NEWS]),
      },
    },
    {
      id: 'countries',
      label: 'Countries',
      group: groups.location,
      type: FT_AUTOCOMPLETE,
      fieldConf: {
        searcher: loadLocations,
        items: loadLocations,
      },
    },
    {
      id: 'regions',
      label: 'Regions',
      group: groups.location,
      type: FT_AUTOCOMPLETE,
      fieldConf: {
        searcher: loadRegions,
      },
    },
  ],
  searchBarProp: 'complex_name',
};
